import {useEffect} from "react";
import {Box, Button, Card, CardContent, Grid, IconButton, Modal, TextField, Typography} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import {Controller, useForm} from "react-hook-form";
import {msg} from "@lingui/macro";
import UploadDropzone from "../../uploadFile/UploadDropzone";
import UploadFileProgress from "../../uploadFile/UploadFileProgress";
import {useLingui} from "@lingui/react";
import httpReq from "../../../services/httpReq";

const ModalEditVideo = ({video, setVideo}) => {
    const {control, formState, handleSubmit, getValues} = useForm({
        mode: 'onChange',
        defaultValues: {
            title: video.title,
            description: video.description,
        }
    })
    const {_} = useLingui()


    const updateVideo = async () => {
        const formValues = getValues()
        const dataToSend = {
            title: formValues.title,
            description: formValues.description,
            id: video.id,
            projectFk: video.project.id,
            fileName: video.fileName,
            fileMimeType: video.fileMimeType,
            fileExtension: video.fileExtension,

        }
        console.log('dataToSend', dataToSend);
        httpReq('Video/GenerateTracks/' + video.id, 'GET', null, true).then(() => {
        })
        const res = await httpReq('Video/Update', 'PATCH', dataToSend, true);
        if (!res || res.responseAnyError) return;
        setVideo(null)

    }

    return (
        <Modal sx={{display: 'flex'}} open={!!video}>
            <Card sx={{width: '25vw', height: '100vh', padding: 2}}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        px: 2,
                        py: 1.5,
                    }}
                >
                    <Typography variant="h6" sx={{flex: 1}}>
                        {_(msg`Edit video`)}: {video.title}
                    </Typography>

                    <Box sx={{flex: 1, display: 'flex', justifyContent: 'flex-end', gap: 1}}>
                        <Button sx={{borderRadius: 10}} variant="contained" disabled={!formState.isValid}
                                onClick={() => updateVideo()}>
                            <SaveIcon color={!formState.isValid ? 'inherit' : 'white'}/>
                        </Button>
                        <IconButton onClick={() => {
                            setVideo(null)
                        }}>
                            <CloseIcon color="error"/>
                        </IconButton>
                    </Box>
                </Box>
                <CardContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <Controller
                                name='title'
                                control={control}
                                defaultValue=""
                                rules={{required: _(msg`Title is required`)}}
                                render={({field, fieldState}) => (
                                    <TextField
                                        margin={'normal'}
                                        fullWidth
                                        required
                                        label={_(msg`Title`)}
                                        autoComplete='title'
                                        autoFocus
                                        error={!!fieldState.error}
                                        helperText={fieldState.error ? fieldState.error.message : null}
                                        {...field}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name='description'
                                control={control}
                                rules={{required: _(msg`Description is required`)}}
                                defaultValue=""
                                render={({field, fieldState}) => (
                                    <TextField
                                        margin={'normal'}
                                        fullWidth
                                        required
                                        label={_(msg`Description`)}
                                        autoComplete='description'
                                        autoFocus
                                        error={!!fieldState.error}
                                        helperText={fieldState.error ? fieldState.error.message : null}
                                        {...field}
                                    />
                                )}
                            />
                        </Grid>


                    </Grid>
                </CardContent>
            </Card>
        </Modal>
    )
}
export default ModalEditVideo